import { css } from 'jimu-core';
import { getBoxStyles } from 'jimu-theme';
export const cardStyles = (props) => {
    var _a, _b, _c, _d;
    const horizontal = props.horizontal;
    const button = props.button;
    const active = props.active;
    const theme = props.theme;
    const cardVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.card;
    const { root, spacer, divider, headerBg, checkMark } = cardVars;
    const innerBorderRadius = `calc(${(_b = root === null || root === void 0 ? void 0 : root.default) === null || _b === void 0 ? void 0 : _b.borderRadius} - ${(_d = (_c = root === null || root === void 0 ? void 0 : root.default) === null || _c === void 0 ? void 0 : _c.border) === null || _d === void 0 ? void 0 : _d.width})`;
    return cardVars && css `
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    ${getBoxStyles(root === null || root === void 0 ? void 0 : root.default)};

    > hr {
      margin-right: 0;
      margin-left: 0;
    }

    .card-body {
      flex: 1 1 auto;
      padding: ${spacer.x};
    }

    .card-header {
      padding: ${spacer.y} ${spacer.x};
      margin-bottom: 0;
      background-color: ${headerBg};
      border-bottom: ${divider.width} solid ${divider.color};
      border-radius: ${innerBorderRadius} ${innerBorderRadius} 0 0;
    }

    .card-footer {
      padding: ${spacer.y} 0;
      margin: 0 ${spacer.x};
      background-color: ${headerBg};
      border-top: ${divider.width} solid ${divider.color};
      border-radius: 0 0 ${innerBorderRadius} ${innerBorderRadius};
    }

    /* Horizontal */

    ${horizontal && css `
      &.card-horizontal {
        flex-direction: row;
      }
    `}

    /* Button Card */

    ${button && css `
      &.card-button {
        cursor: pointer;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        &:hover {
          ${getBoxStyles(root === null || root === void 0 ? void 0 : root.hover)};
        }
      }
    `}

    /* Active Card */

    ${active && css `
      &.card-active {
        position: relative;
        ${getBoxStyles(root === null || root === void 0 ? void 0 : root.active)};
        .card-checkmark {
          position: absolute;
          right: 0;
          z-index: 1;
          padding: 0.25rem;
          line-height: 1;
          ${getBoxStyles(checkMark)}
        }
      }
    `}
  `;
};
